import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import ScrollReveal from "./ScrollReveal";

const NoCloseGuarantee = () => {
  const navigate = useNavigate();

  return (
    <section className="py-24 px-4 bg-primary/90 border-y border-primary/20">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center">
        
        {/* Heading */}
        <ScrollReveal>
          <h2 className="text-4xl md:text-5xl font-bold text-background leading-tight mb-6 uppercase">
            NO CLOSE GUARANTEE
          </h2>
        </ScrollReveal>
        
        {/* Paragraph */}
        <ScrollReveal delay={0.1}>
          <p className="text-lg md:text-xl text-background/90 max-w-3xl mx-auto leading-relaxed mb-10">
            We understand that not all transactions conclude successfully. Therefore, we offer a "No Close guarantee", if your file doesn't close, you don't pay!
          </p>
        </ScrollReveal>
        
        {/* Button */}
        <ScrollReveal delay={0.2}>
          <Button 
            size="lg" 
            className="w-full sm:w-auto bg-white text-slate-900 hover:bg-slate-100 hover:text-slate-900 text-lg px-10 py-7 h-auto shadow-lg hover:scale-105 transition-all font-semibold"
            onClick={() => {
              navigate('/get-started');
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            Get Started
          </Button>
        </ScrollReveal>

      </div>
    </section>
  );
};

export default NoCloseGuarantee;